import React from "react";
import { centsToCurrencyString } from "../../../utils/numbers";
import { CatalogGridItemProps } from "../../common/CatalogGrid/types";
import { CandybarItemType } from "./types";
import { getCandybarItemPriceWithSelectedOptions } from "../../../utils/candybar";
import styled from "styled-components";
import { breakpoints } from "../../../utils/styles";

const Item = styled.div<{clickable?: boolean}>`
    border: 1px solid var(--text-primary);
    --fgcolor: var(--text-primary);

    ${props => props.clickable && `
        cursor: pointer;

        @media screen and (min-width: ${breakpoints.desktop}px) {
            &:hover {
                --fgcolor: var(--page-bg);
                background: var(--primary);
                color: var(--fgcolor);

                body.theme-platinum & {
                    --fgcolor: var(--text-primary);
                }
            }
        }
    `}
`;

const Thumb = styled.img`
    display: block;
    height: auto;
    width: 100%;
`;

const Info = styled.div`
    padding: 1em;
    position: relative;
`;

const Name = styled.p`
    font-weight: 900;
    font-size: ${(14/12.6).toFixed(3)}em;

    body.theme-market & { font-family: var(--ff-subtitle); }
`;

const Price = styled.p<{center?: boolean}>`
    margin: 0 0 0.25em;
    ${props => props.center ? 'text-align: center; margin-bottom: 0;' : ''}
`;

const Button = styled.button<{left?: boolean, disc?: boolean}>`
    background: none;
    border: 0;
    bottom: 1em;
    color: var(--fgcolor);
    cursor: pointer;
    outline: none;
    padding: 0;
    position: absolute;

    &:focus { outline: none; }

    ${props => props.disc && `
        border: 1px solid var(--fgcolor);
        border-radius: 100%;
        width: 2rem;
        height: 2rem;
        text-align: center;
        line-height: 1.7rem;
    `}
    
    ${props => props.left ? 'left: 1em' : 'right: 1em'};
`;

class CandybarGridItem extends React.Component<CatalogGridItemProps> {
    render() {
        const item = this.props.item as CandybarItemType;
        const {actions} = this.props;
        const isOrderItem = ('unitId' in item);
        
        return <Item onClick={!isOrderItem ? () => actions.onAdd(item.id) : undefined} clickable={!isOrderItem}>
            {item.thumb && <Thumb src={item.thumb} alt={'Foto de ' + item.name}/>}

            <Info>
                <Name>{item.name}</Name>

                <Price center={isOrderItem}>{centsToCurrencyString(this.getPrice())}</Price>

                {!isOrderItem && <Button disc>
                    <em className="fal fa-plus"></em>
                </Button>}
                
                {isOrderItem && <React.Fragment>
                    <Button onClick={() => actions.onAdd(item.id, item.unitId)} left>
                        <em className="fal fa-pencil"></em>
                    </Button>
                    <Button onClick={() => actions.onRemove(item.id, item.unitId)}>
                        <em className="fal fa-trash"></em>
                    </Button>
                </React.Fragment>}
            </Info>
        </Item>
    }

    getPrice() {
        const item = this.props.item as CandybarItemType;

        if (!item.unitConfig) {
            return item.price;
        }
        
        return getCandybarItemPriceWithSelectedOptions(item, item.unitConfig.config);
    }
}

export default CandybarGridItem;